<template>
  <div>

    <div class="container py-5">

      <div class="row">

        <div class="col-lg-4 col-md-4 col-sm-12 nav-item-profile">

          <router-link to="/perfil/empleos" class="btn b-orange d-md-none d-sm-inline">
            <i class="fas fa-long-arrow-alt-left"></i>
            Volver a empleos
          </router-link>

          <div class="font-gray-dark my-2">Información de empleo</div>

          <div class="_jobinfo shadow-sm b-white p-2 rounded">
            <h5 class="font-blue">{{ jobData.titulo }}</h5>
            <hr>
            <ul class="list-unstyled ml-3">
              <li>{{ jobData.ubicacion }}</li>
              <li>publicado hace {{ jobData.created_at | timeDateHummand }}</li>
            </ul>
          </div>
          <br>
          <div class="font-gray-dark my-1">Gestión de candidatos</div>
          <b-nav vertical class="w-100 d-none d-md-block">
            <!--<b-nav-item active :to="'/job/' + idJob + '/candidates'"><i class="fas fa-info-circle"></i> Introducción</b-nav-item>-->
            <b-nav-item active :to="'/job/' + idJob + '/candidates/view'"><i class="fas fa-user-friends"></i>
              Postulaciones
              <b-badge class="float-right b-green">{{ jobData.candidates_count }}</b-badge>
            </b-nav-item>
            <b-nav-item to="/perfil/empleos"><i class="fas fa-home"></i> Volver a Empleos</b-nav-item>
          </b-nav>
          <!-- <small class="font-blue">Candidatos ({{candidates.length || 0}})</small> -->
          <div class="__profilelist">

            <!-- <CandidateTarget v-for="(candidate, key) in candidates" :key="key" :unique="key" :id="candidate.candidate.id" :name="candidate.candidate.name" :avatar="candidate.candidate.avatar" :status="candidate.status"/>
            <div class="__none_candidates b-white p-3 rounded shadow-sm font-gray-dark" v-if="candidates.length == 0">
                Aquí se mostraran tus candidatos. Por el momento no se han encontrado candidatos para este empleo.
            </div> -->
          </div>
        </div>

        <div class="col-lg-8 col-md-8 col-sm-12 mt-4">

          <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
            <b-spinner small label="Espere ..."></b-spinner>
            <span class="p-1">Espere un momento...</span>
          </div>
          <router-view :key="idJob" v-else
                       :idJob="idJob"
                       :candidates="jobData.candidates"
                       :matches="jobData.matches_data"
                       :isGold="jobData.is_gold"
          >
          </router-view>
        </div>

      </div>

    </div>

  </div>
</template>
<script>
import CandidateTarget from './components/CandidateTarget'

export default {
  components: {
    'CandidateTarget': CandidateTarget
  },
  data() {
    return {
      downloading: false,
      idJob: this.$route.params.idjob,
      status: 'send',
      jobData: {}
    }
  },
  watch: {
    status: function (status) {
      this.loadJob(status)
    }
  },
  methods: {
    viewCandidate(idcandidate) {
      this.$router.push('/job/' + this.idJob + '/candidates/view/' + idcandidate).catch(err => {
      })
    },

    changeStatusList(key, status) {
      this.candidates[key].status = status
    },
    loadJob(status) {
      this.downloading = true
      this.api.get('candidate/job?job_id=' + this.idJob + '&status=' + status).then(({data}) => {
        this.jobData = data
        this.downloading = false
        this.$forceUpdate()
      }).catch(err => {
        this.downloading = false
      })
    }
  },
  created() {
    this.loadJob(this.status)
    this.$bus.$on("change_candidate_status", () => {
      this.loadJob(this.status)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/Candidates.vue